import { c as _c } from "react/compiler-runtime";
import type { ProcessedContent } from "./media-utils";
import ContentSegmentComponent from "./ContentSegmentComponent";
import MediaThumbnail from "./MediaThumbnail";
interface ContentDisplayProps {
  readonly content: ProcessedContent;
  readonly onClick?: () => void;
  readonly className?: string | undefined;
  readonly textClassName?: string | undefined;
  readonly shouldClamp?: boolean;
  readonly linkify?: boolean;
}

/**
 * Component to display processed content with text segments and media
 */
export default function ContentDisplay(t0) {
  const $ = _c(21);
  const {
    content,
    onClick,
    className,
    textClassName,
    shouldClamp: t1,
    linkify: t2
  } = t0;
  const shouldClamp = t1 === undefined ? true : t1;
  const linkify = t2 === undefined ? true : t2;
  const clampClass = shouldClamp ? "tw-line-clamp-1" : "";
  const t3 = onClick ? "tw-cursor-pointer hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out" : "";
  const t4 = className ?? "";
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = ["tw-text-iron-300 tw-font-normal tw-text-sm tw-flex tw-items-center tw-gap-1.5", t3, t4].filter(Boolean);
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const containerClasses = t5.join(" ");
  const t6 = textClassName ?? "";
  let t7;
  if ($[3] !== clampClass || $[4] !== t6) {
    t7 = [clampClass, t6].filter(Boolean);
    $[3] = clampClass;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const textClasses = t7.join(" ");
  let t8;
  if ($[6] !== content.segments || $[7] !== linkify) {
    let t9;
    if ($[9] !== linkify) {
      t9 = (segment, i) => <ContentSegmentComponent key={`segment-${i}`} segment={segment} index={i} linkify={linkify} />;
      $[9] = linkify;
      $[10] = t9;
    } else {
      t9 = $[10];
    }
    t8 = content.segments.map(t9);
    $[6] = content.segments;
    $[7] = linkify;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[11] !== t8 || $[12] !== textClasses) {
    t9 = <span className={textClasses}>{t8}</span>;
    $[11] = t8;
    $[12] = textClasses;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== content.apiMedia) {
    t10 = content.apiMedia.map(_temp);
    $[14] = content.apiMedia;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== containerClasses || $[17] !== onClick || $[18] !== t10 || $[19] !== t9) {
    t11 = <span className={containerClasses} onClick={onClick}>{t9}{t10}</span>;
    $[16] = containerClasses;
    $[17] = onClick;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp(media, i_0) {
  return <MediaThumbnail key={`api-media-${i_0}`} media={media} />;
}